import './two-columns-two-image-link.scss';
